import { render, staticRenderFns } from "./scorm.vue?vue&type=template&id=1ce16886"
import script from "./scorm.vue?vue&type=script&lang=js"
export * from "./scorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports